import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  .icon {
    border-radius: var(--rounding-radius-xs, 8px);
    border: 1px solid var(--border-image-edge, rgba(178, 162, 162, 0.32));
    overflow: hidden;
    min-width: 48px;
    width: 48px;
    height: 48px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .arrow-right {
    margin-left: auto;
  }
`;
